import type { UtenteCorrente } from '@aulaviva/shared';
import { Button, Outcome } from '@aulaviva/ui';
import { ShieldCheck } from 'lucide-react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { navGestione, sicurezza } from '@/testi';
import { Intestazione } from './Intestazione';
import { useUtenteArea } from './utente';

/** Senza secondo fattore l'area amministratore è bloccata: lì si vedono i codici fiscali. */
export function areaAdminBloccata(utente: Pick<UtenteCorrente, 'totpRichiesto'>, pathname: string): boolean {
  return utente.totpRichiesto && pathname.startsWith('/admin');
}

export function AvvisoTotpRichiesto({ onVai }: { onVai: () => void }) {
  return (
    <Outcome
      variant="warning"
      title={sicurezza.guardAdmin.titolo}
      action={
        <Button variant="primary" icon={ShieldCheck} onClick={onVai}>
          {sicurezza.guardAdmin.azione}
        </Button>
      }
    >
      {sicurezza.guardAdmin.testo}
    </Outcome>
  );
}

/** Area di gestione per relatore, regia e amministratore: stesse fondamenta, voci diverse. */
export function LayoutGestione() {
  const utente = useUtenteArea();
  const ruolo = utente.ruolo === 'partecipante' ? 'relatore' : utente.ruolo;
  const voci = navGestione[ruolo];
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <div className="min-h-dvh flex flex-col">
      <Intestazione voci={voci} home={voci[0]!.to} etichettaRuolo={navGestione.ruolo[ruolo]} />
      <main id="contenuto" className="contenitore flex-1 py-8 md:py-12 flex flex-col gap-8">
        {areaAdminBloccata(utente, pathname) ? <AvvisoTotpRichiesto onVai={() => navigate('/sicurezza?motivo=totp')} /> : <Outlet />}
      </main>
    </div>
  );
}
